import type {FC} from 'react'
import {Tooltip, Typography} from '@mui/material'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import type {DeliveryLabel} from '@containers/Dashboards/AgentChat/components/conversationRun/runState'

/**
 * How a message sent while Alpinist worked reached it (AB#6760): still
 * waiting, taken into the running answer, answered as the next turn, or
 * withdrawn by Stop. Under the bubble, where the sender looks for it; the
 * tooltip says what the word means for their message.
 */
const DeliveryNote: FC<{label: DeliveryLabel}> = ({label}) => {
  const [t] = useCustomTranslation('alpinist')

  return (
    <Tooltip title={t(`delivery_${label}_hint`)} placement="left">
      <Typography variant="caption" color="text.secondary" sx={{mr: 0.5, lineHeight: 1.2}}>
        {t(`delivery_${label}`)}
      </Typography>
    </Tooltip>
  )
}

export default DeliveryNote
